import { render, staticRenderFns } from "./CompliancePolicy.vue?vue&type=template&id=e2fc3b36&scoped=true&"
import script from "./CompliancePolicy.vue?vue&type=script&lang=js&"
export * from "./CompliancePolicy.vue?vue&type=script&lang=js&"
import style0 from "./CompliancePolicy.vue?vue&type=style&index=0&id=e2fc3b36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fc3b36",
  null
  
)

export default component.exports